import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import WorkPage from './pages/WorkPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PortfolioPage from './pages/utah/PortfolioPage'; // Add this import
import AkronPortfolioPage from './pages/akron/PortfolioPage';
import './App.css';

// ScrollToTop function
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

// AppContent component to handle conditional header/footer
function AppContent() {
  const location = useLocation();
  
  // Hide header and footer for portfolio pages
  const hideHeaderFooter = location.pathname === '/utah' || 
                           location.pathname === '/portfolio-presentation' ||
                           location.pathname === '/akron';

  return (
    <div className="App">
      {!hideHeaderFooter && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/work" element={<WorkPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/utah" element={<PortfolioPage />} />
          <Route path="/portfolio-presentation" element={<PortfolioPage />} />
          <Route path="/akron" element={<AkronPortfolioPage />} />
        </Routes>
      </main>
      {!hideHeaderFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* Keep your ScrollToTop functionality */}
      <AppContent />
    </Router>
  );
}

export default App;
